import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { PensionArrangementClient } from "../../../../../../Wrap/Api/Account/PensionArrangement";
import { GiaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/GiaContributionInstruction";
import { IsaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/IsaContributionInstruction";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { WhatIfToolCopyClient } from "../../../../../../Wrap/Api/Apply/WhatIfToolCopy";
import { WhatIfToolInstructionClient } from "../../../../../../Wrap/Api/Apply/WhatIfToolInstruction";
import { CappedPensionArrangementsFlexiConversionAvailabilitiesClient } from "../../../../../../Wrap/Api/Drawdown/CappedPensionArrangementsFlexiConversionAvailabilities";
import { DrawdownInstructionClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownInstruction";
import { DrawdownSinglePaymentInstructionClient } from "../../../../../../Wrap/Api/Drawdown/DrawdownSinglePaymentInstruction";
import { PensionArrangementType } from "../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { ProcessType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PensionArrangementStatus } from "../../../../../../Wrap/Constants/Enums/Drawdown/PensionArrangementStatus";
import { PensionArrangement } from "../../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { WhatIfToolDisaptcher } from "../Store/Variable";
import { Arrangements } from "../../EditIncomeWithdrawalsWizard/Actions/Arrangements";
import { InstructionAdditionalDataItem } from "../../../../../../Wrap/Models/Models/Instructions/InstructionAdditionalDataItem";
import { InstructionAdditionalDataItemClient } from "../../../../../../Wrap/Api/Instruction/InstructionAdditionalDataItem";

export class WhatIfAction {
    public static getInstruction(
        id: string,
        hierarchyId: string,
        subAccountHierarchyId: string,
        clientId: number,
        productType: SubAccountType,
        batchId: number,
        callback?: VoidFunction,
    ): void {
        if (SubAccountTypeHelper.isPP(productType)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            this.getOrCreateInstruction(
                giaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                batchId,
                callback
            );
        } else if (SubAccountTypeHelper.isIsa(productType)) {
            const isaContributionInstruction = new IsaContributionInstructionClient();
            this.getOrCreateInstruction(
                isaContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                batchId,
                callback
            );
        } else if (SubAccountTypeHelper.isOnPlatformPension(productType)) {
            const nprContributionInstruction = new PensionContributionInstructionClient();
            this.getOrCreateInstruction(
                nprContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId,
                batchId,
                callback
            );
        }
    }

    public static saveInstruction(from, data: any, type, customerId?, callback?: (data) => void): void {
        if (SubAccountTypeHelper.isPP(type)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            const promise = giaContributionInstruction.put(data, "");
            this.updateWhatiIfInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const client = new IsaContributionInstructionClient();
            const promise = client.put(data);
            this.updateWhatiIfInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            const client = new PensionContributionInstructionClient();
            let promise = client.put(data, customerId,null);
            this.updateWhatiIfInstructionStore(promise, callback);
        } else {
            callback([]);
        }
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    private static getOrCreateInstruction(
        client: IsaContributionInstructionClient | GiaContributionInstructionClient | PensionContributionInstructionClient,
        id,
        hierarchyId,
        subAccountHierarchyId,
        clientId,
        batchId,
        callback?: VoidFunction
    ) {
        if (!CommonHelper.isNullOrEmpty(id)) {
            // Have instructionId
            const promise = client.get(id, clientId, "", batchId);
            this.updateWhatiIfInstructionStore(promise, () => { if (callback) callback() });
        } else {
            // Create new instruction
            const promise = client.post(subAccountHierarchyId, hierarchyId, ProcessType.WhatIfTool);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const model = client.get(instructionId, clientId, "", batchId);
                this.updateWhatiIfInstructionStore(model, () => { if (callback) callback() });
            });

            promise.onError((err) => {
                WhatIfToolDisaptcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
        }
    }

    public static CreateDrawdownInstruction(
        hierarchyId,
        clientId
    ): void {
        const client = new DrawdownInstructionClient();
        const promise = client.post(hierarchyId, null, false, false, false);
        promise.onSuccess((result) => {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            const hierarchyId = result.Result.HierarchyId;
            const model = pensionContributionInstruction.get(hierarchyId, clientId, "",
            //  null
             );
            this.updateWhatiIfInstructionStore(model);
        });
        promise.onError((error) => { });
    }

    public static createOneOffIncomeModel(subAccountAmendmendHierarchyId, subAccountHierarchyId, clientId) {
        const client = new DrawdownSinglePaymentInstructionClient();
        let instruction = { HierarchyId: subAccountAmendmendHierarchyId }
        // Create new instruction
        const promise = client.post(subAccountHierarchyId, instruction);

        promise.onSuccess((result) => {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            const model = pensionContributionInstruction.get(subAccountAmendmendHierarchyId, clientId, "");
            this.updateWhatiIfInstructionStore(model);
        });
        promise.onError((error) => { });
    }

    private static updateWhatiIfInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            WhatIfToolDisaptcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors.map((ele) => ele.UserMessage));
            } else {
                callback(result);
            }
        });

        promise.onError((err) => {
            WhatIfToolDisaptcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }

    public static getPrepopulateData(
        subAccountHierarchyId: string,
        headHierarchyId: string,
        batchId: number,
        callback
    ) {
        const client = new WhatIfToolInstructionClient();
        const promise = client.get(subAccountHierarchyId, headHierarchyId, batchId);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static submitInstruction(instructionId: string, callback) {
        const client = new WhatIfToolInstructionClient();
        const promise = client.put(instructionId);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static copyInstruction(instructionId: string, subHierarchyId: string, type: SubAccountType, callback) {
        const client = new WhatIfToolCopyClient();
        const promise = client.put(instructionId, subHierarchyId, type);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static getPensionArrangementDetails(hierarchyId: string, includeClosed: boolean, callback: (data: PensionArrangement[]) => void) {
        const client = new PensionArrangementClient();
        const promise = client.get(hierarchyId, includeClosed);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => { });
    }

    public static getCappedArrangementDetails(subAccountHierarchyId: string, callback?: (result) => void): void {
        const availabilitiesClient = new CappedPensionArrangementsFlexiConversionAvailabilitiesClient();
        const promise = availabilitiesClient.get(
            subAccountHierarchyId
        );
        promise.onSuccess((result) => {
            if (callback) callback(result);
        });
    }


    public static getActiveRetirementArrangementsByType(pensionArrangements: PensionArrangement[], type: PensionArrangementType): PensionArrangement[] {
        return pensionArrangements.filter((ele) => { return ele.Type == type && ele.Status == PensionArrangementStatus.Active });
    }

    public static getInstructionAdditionalDataItem(instructionId: number, callback: (data: InstructionAdditionalDataItem[]) => void) {
        const instructionAdditionalDataItemClient = new InstructionAdditionalDataItemClient();
        const promise = instructionAdditionalDataItemClient.get(
            instructionId
        );
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static putInstructionAdditionalDataItem(instructionId: number, instructionAdditionalDataItems: InstructionAdditionalDataItem[], callback) {
        const client = new InstructionAdditionalDataItemClient();
        const promise = client.put(instructionId, instructionAdditionalDataItems);
        promise.onSuccess((data) => {
            callback(data);
        });
    }

    public static getMockupExistingArrangments(): Arrangements {
        const existingArrangements =
        {
            CappedModels: [
                {
                    Id: 1,
                    From: "test1",
                    Amount: 111,
                    Type: "Capped",
                    GadMaximum: 112,
                    Taxable: true,
                    IncomeTakenToDate: 11,
                    NextYearsGadMaximum: 122,
                    LastMandatoryReview: JsonDateParser.toJsonDate(new Date("2023-12-06T06:16:17.01")),
                    MaximumIncomePaymentForRemainderOfPensionYear: 10,
                    MaximumIncomePaymentForFuturePensionYears: 10,
                    IncomePerPaymentForCurrentPensionYear: 10,
                    IncomePerPaymentForFuturePensionYears: 10,
                },
                {
                    Id: 2,
                    From: "test2",
                    Amount: 222,
                    Type: "Capped",
                    GadMaximum: 223,
                    Taxable: true,
                    IncomeTakenToDate: 22,
                    NextYearsGadMaximum: 233,
                    LastMandatoryReview: JsonDateParser.toJsonDate(new Date("2023-12-06T06:16:17.01")),
                    MaximumIncomePaymentForRemainderOfPensionYear: 10,
                    MaximumIncomePaymentForFuturePensionYears: 10,
                    IncomePerPaymentForCurrentPensionYear: 10,
                    IncomePerPaymentForFuturePensionYears: 10,
                }
            ],
            FlexiModels: [
                {
                    Id: 3,
                    From: "test3",
                    Amount: 333,
                    Type: "Crystallisation",
                    MaximumIncomePerPayment: 331,
                    IncomePerPayment: 33,
                    TakeFullValue: false,

                },
                {
                    Id: 4,
                    From: "test4",
                    Amount: 444,
                    Type: "Crystallisation",
                    MaximumIncomePerPayment: 400,
                    IncomePerPayment: 44,
                    TakeFullValue: false,
                }
            ]
        }
        return existingArrangements;
    }
}
